import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

export default class Heading extends React.Component {
  constructor(props) {
    super(props)

    this.config = {
      types : [
        'inverse'
      ],
      modifiers : [ 
        'xxs',
        'xs',
        'sm',
        {
          title: 'md',
          isDefault: true,
        },
        'lg',
        'xl',
        'xxl'
      ],
    }

  }
  
  render() {
    const { children, tag, ...rest } = this.props
    let CustomTag = tag || 'h1';
    const props = clearProps(this.props)
    return <CustomTag {...rest} className={resolveProps(this.props, this.config,'Heading')}>
      {children}
    </CustomTag>
  }
}

Heading.propTypes = {
  children : PropTypes.string,

}